import classNames from "classnames";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TreeTable } from "primereact/treetable";
import { useEffect, useState } from "react";
import { FaFileExcel, FaSearch, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import AppCard from "../../../../components/appCard";
import { Api } from "../../../../services/api";
import { DropdownPague, TreeTablePague } from "../../../../styles/primeReactConfig";
import formatDocument from "../../../../utils/formatCurrency";
import GeraXLSX from "../../../../utils/GeraXLSX";


function RelatorioNegociacoes() {

  const [infoNegociacoes, setInfoNegociacoes] = useState([]);
  const [page, setPage] = useState(0);
  const [first, setFirst] = useState(0);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState(10);
  const [rowsPerPageOptions] = useState([10, 20, 50]);
  const [loadTree, setLoadTree] = useState(true);
  const [loadingXLSX, setLoadingXLSX] = useState(false)
  const [reload, setReload] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [varSearch, setVarSearch] = useState();
  const [searchState, setSearchState] = useState(false);

  useEffect(() => {
    searchTable()
  }, [reload])

  //chamada de API e lógica

  const searchTable = async () => {
    setLoadTree(true)
    let searchParam = undefined
    let filter = 'all'
    if (searchState === true) {
      filter = selectedFilter
      searchParam = varSearch
      if (selectedFilter === 'documento' && varSearch !== undefined)
        searchParam = unMask(varSearch)
    }
    try {
      const { data } = await Api.get(`genericnegotiation/lista-negociacoes/${rows}/${page}/${filter}/${searchParam}`)
      if (data.length === 0) {
        setSearchState(false)
        toast.error('Nenhuma negociação encontrada')
      }
      const negotiationTreeData = formatTreeTableData(data)
      setInfoNegociacoes(negotiationTreeData)
      setTotal(data[0].count)
    } catch (error) {
      console.log(error)
    }
    finally {
      setLoadTree(false)
    }
  }

  function handleSearch(e) {
    if (e.key === 'Enter') {
      if (varSearch === undefined)
        return setReload(prevReload => !prevReload);
      if (selectedFilter === "document" && (varSearch.length === 14 || varSearch.length === 18)) {
        setSearchState(true)
        return setReload(prevReload => !prevReload);
      }
      if (varSearch.length === 0) {
        setSearchState(false)
        setSelectedFilter('all')
        return setReload(prevReload => !prevReload);
      }
      if (selectedFilter !== "all" && selectedFilter !== 'document') {
        setSearchState(true)
        return setReload(prevReload => !prevReload);
      }
    }
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload(prevReload => !prevReload);
  }

  const downloadXLSX = async () => {
    let searchParam = undefined
    let filter = 'all'
    // console.log(searchState)
    if (searchState === true) {
      filter = selectedFilter
      searchParam = varSearch
      if (selectedFilter === 'documento' && varSearch !== undefined)
        searchParam = unMask(varSearch)
    }
    setLoadingXLSX(true)
    try {
      const { data } = await Api.get(`genericnegotiation/lista-negociacoes/999999999/0/${filter}/${searchParam}`)
      if (data.length === 0) {
        setSearchState(false)
        toast.error('Nenhuma negociação encontrada')
      }

      const headers = ['Nome', 'Documento', 'Código Cliente', 'Descrição', 'Tipo Pagamento', 'Boletos Pagos', 'Valor Pago', 'Valor Negociação', 'Situação', 'Comunicacões Feitas']
      const fields = ['usuario_nome', 'usuario_documento', 'cobranca_numero_cliente_credor', 'cobranca_descricao', 'tipo_pagamento', 'boletos_pagos', 'valor_pago', 'cobranca_valor', 'situacao', 'vezes_comunicado']
      const parametrosXLSX = {
        data: data,
        headers: headers,
        fields: fields,
        titulo: `Relatorio_de_Negociações_${format(new Date(), 'dd-MM-yyyy')}`
      }
      GeraXLSX(parametrosXLSX)

    } catch (error) {
      console.log(error)
    } finally {
      setLoadingXLSX(false)
    }
  }

  //templates

  const filterOptions = [
    { label: 'Todos', value: "all" },
    { label: 'Nome', value: 'nome' },
    { label: 'Documento', value: 'documento' },
    { label: 'Código do Cliente', value: 'codigocliente' },
  ];

  function formatTreeTableData(data) {
    if (data) {
      let formatedRow = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].filhos.length > 0) {
          formatedRow.push({ key: data[i].cobranca_id, data: data[i], children: [] })
          for (let j = 0; j < data[i].filhos.length; j++) {
            formatedRow[i].children.push({ key: data[i].filhos[j].cobranca_id, data: data[i].filhos[j] })
          }
        } else
          formatedRow.push({ key: i.toString(), data: [] })
        delete data[i].filhos
        delete data[i].id_negociacao
      }
      return formatedRow
    }
    else return []
  }

  function formatCurrency(e) {
    if (e) {
      return (Number(e).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
    }
    return '-';
  }

  const tipoPagamentoTemplate = (e) => {
    let type = "-";
    if (e.data.tipo_pagamento === "cartao") {
      type = 'outofstock';
    }
    if (e.data.tipo_pagamento === "boleto") {
      type = 'instock';
    }

    return (
      e.children && <div className={`product-badge  status-${type}`} style={{ width: 'fit-content', justifySelf: "center", display: "inline-flex" }}>
        <p>
          {e.data.tipo_pagamento}
        </p>
      </div>
    )
  };

  const statusBodyTemplate = (e) => {
    let type = "-";
    let situacao = e.data.situacao ? e.data.situacao : ''

    switch (situacao.toUpperCase()) {
      case 'EM ABERTO':
        type = "bg-sky-200 text-sky-600";
        break;
      case 'PAGO':
      case 'PAGO EM DINHEIRO':
      case 'PAGO (CLIENTE)':
      case 'PAGO JUNTO AO CLIENTE':
      case 'PAGO DURANTE O PROTESTO':
        type = "bg-emerald-300 text-emerald-800";
        break;
      case 'EM PROCESSAMENTO':
      case 'EM PROCESSAMENTO (PARCIAL)':
        type = "bg-orange-300 text-orange-700";
        break;
      case 'EM PROTESTO':
      case 'ENVIADO A PROTESTO':
      case 'ACORDO NÃO PAGO':
        type = "bg-slate-300 text-slate-700";
        break;
      default:
        type = "-"
        break;
    }
    return (
      e.children &&
      <div className="flex justify-center items-center ">
        <span className={classNames(
          'text-nowrap py-1 px-2 justify-center flex w-auto',
          type
        )}
        >
          <p className="uppercase text-sm font-bold">
            {situacao}
          </p>
        </span>
      </div>
    )
  };

  const documentTemplate = (e) => {
    if (e.data.usuario_documento) {
      return formatDocument(e.data.usuario_documento)
    } else {
      return '-'
    }
  };

  const rowClassName = (node) => {
    return { 'surface-200': (!node.children), 'hidden': (node.data.length === 0) };
  }

  const tableHeader = (
    <div className="flex justify-between">
      <div className="flex justify-start mt-2">
        <div className="flex">
          <div className='w-3/6'>
            <Dropdown
              value={selectedFilter}
              pt={DropdownPague}
              options={filterOptions}
              emptyMessage="Selecione um filtro"
              onChange={(e) => { setSelectedFilter(e.value); setVarSearch() }}
              style={{ width: '100%' }}
            />
          </div>
          {selectedFilter === "documento" &&
            <div className='w-3/6'>
              <InputText
                value={varSearch}
                onChange={e => setVarSearch(
                  mask(unMask(e.target.value), [
                    '999.999.999-99',
                    '99.999.999/9999-99',
                  ]),
                )}
                placeholder="Busca por CPF/CNPJ"
                onKeyDown={e => handleSearch(e)}
              />
            </div>
          }
          {selectedFilter === "codigocliente" &&
            <div className='w-3/6'>
              <InputText
                value={varSearch}
                onChange={e => setVarSearch(e.target.value)}
                placeholder="Busca por Código do Cliente"
                onKeyDown={e => handleSearch(e)}
              />
            </div>
          }
          {selectedFilter === "nome" &&
            <div className='w-3/6'>
              <InputText
                value={varSearch}
                onChange={e => setVarSearch(e.target.value)}
                placeholder="Busca por Nome"
                onKeyDown={e => { handleSearch(e) }}
              />
            </div>
          }
          <div className="md:ml-2">
            <Button
              severity="success"
              icon={<FaSearch />}
              onClick={() => { handleSearch({ key: 'Enter' }) }}
            />
          </div>
          <div className="md:ml-2">
            <Button
              severity="danger"
              icon={<FaTimes />}
              // style={{width:'4em'}}
              onClick={() => {
                setVarSearch();
                setSearchState(false)
                setSelectedFilter('all')
                handleSearch({ key: 'Enter' })
              }}
            />
          </div>
        </div>
      </div>
      <div>
        <Button
          severity="success"
          icon={<FaFileExcel />}
          loading={loadingXLSX}
          onClick={() => {
            downloadXLSX()
          }}
        />
      </div>
    </div>
  )

  return (
    <AppCard>
      
      <div className="w-full">
        <h4><b>Relatório de Negociações</b></h4>
        <TreeTable
          value={infoNegociacoes}
          header={tableHeader}
          loading={loadTree}
          totalRecords={total}
          rowsPerPageOptions={rowsPerPageOptions}
          rows={rows}
          pt={TreeTablePague}
          first={first}
          onPage={onPage}
          rowClassName={rowClassName}
          paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
          currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
          paginator
          lazy
        >
          <Column header="Nome" field="usuario_nome" expander />
          <Column header="Documento" body={documentTemplate} />
          <Column header="Código Cliente" field="cobranca_numero_cliente_credor" />
          <Column header="Descrição" field="cobranca_descricao" />
          <Column header="Tipo Pagamento" field="tipo_pagamento" body={tipoPagamentoTemplate} />
          <Column header="Boletos Pagos" field="boletos_pagos" />
          <Column header="Valor Pago" field="valor_pago" body={rowData => formatCurrency(rowData.data.valor_pago)} />
          <Column header="Valor Negociação" field="cobranca_valor" body={rowData => formatCurrency(rowData.data.cobranca_valor)} />
          <Column header="Situação" field="situacao" body={statusBodyTemplate} />
          <Column header="Comunicações Feitas" field="vezes_comunicado" />
        </TreeTable>
      </div>
    </AppCard>
  )
}

export default RelatorioNegociacoes